import { render, staticRenderFns } from "./IconSvgForums.vue?vue&type=template&id=303825e5&scoped=true&"
import script from "./IconSvgForums.vue?vue&type=script&lang=js&"
export * from "./IconSvgForums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303825e5",
  null
  
)

export default component.exports